export function getKeyboardEventCode(event: KeyboardEvent): string {
  return (event as any).code || event.key || (event as any).keyIdentifier;
}
